import { useGetRequest } from "../../../Client";

export default function AdvisorDropdown(props) {
  const { status: statusAdvisors, data: dataAdvisors } = useGetRequest(
    "people/dropdown/advisors/strategies",
    {}
  );

  // loading fallback
  if (statusAdvisors !== "fetched") {
    return (
      <div className="w-1/5 p-2">
        <label className="block mb-2 h-5 text-sm font-medium text-gray-900 dark:text-white">
          {props.label}
        </label>
        <div className="h-10 rounded-md bg-gray-100 dark:bg-gray-700 animate-pulse" />
      </div>
    );
  }

  const advisors = dataAdvisors?.people ?? [];

  return (
    <div className="w-1/5 p-2">
      <label
        htmlFor={props.name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {props.label}
        {props.label === "Team Leader" ? "*" : ""}
      </label>

      <select
        id={props.name}
        name={props.name}
        // 👇 controlled value: keep type consistent (string for the DOM, but we cast to number on change)
        value={props.value != null && props.value !== 0 ? String(props.value) : ""}
        onChange={(e) =>
          props.handleChange({
            target: {
              name: props.name,
              // store as number (0 when cleared)
              value: e.target.value ? Number(e.target.value) : 0,
            },
          })
        }
        required={props.label === "Team Leader"}
        className="pl-2 bg-gray-50 h-10 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6 dark:bg-gray-700 dark:text-white dark:ring-gray-600"
      >
        <option value="">Select advisor…</option>
        {advisors.map((advisor) => (
          <option key={advisor.personID} value={String(advisor.personID)}>
            {advisor.surname}, {advisor.firstName}
          </option>
        ))}
      </select>
    </div>
  );
}
